import { Model }            from 'backbone';
import listService from '../../service/ListService';

class MobileSectionModel extends Model {

    initialize() {
    }

    updateSection (sectionId) {
            const section = listService.getSectionById(sectionId).get(sectionId);
            this.attributes.id = section.id;
            this.attributes.name = section.name;
            this.attributes.pageId= section.pageId;
            this.attributes.columnId = section.columnId;
            this.attributes.index = section.index;
            this.attributes.mobileObjects = listService.getMobileObjectsBySectionId(this.id)
    }

    isEmpty() {
        return this.attributes.mobileObjects && this.attributes.mobileObjects.size > 0
    }

    allControlsHiddenState() {
        return this.attributes.mobileObjects.every(control => control.state === 'hidden');
    }

}

export default MobileSectionModel;